import styled from "styled-components";

export const ViewerImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const ViewerVideo = styled.video`
  max-width: 100%;
  max-height: 100%;
`;

export const ViewerAudio = styled.audio`
  width: min(480px, 100%);
`;

/* DocumentPreview sizes its pages to 100% of its parent's height, so the
   parent needs a definite height or the page overflows its page controls. */
export const DocumentFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Stage = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Unavailable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs, 4px);
  text-align: center;
  color: var(--color-subtle, #7d7e84);
`;

export const UnavailableTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--color-gray-950, #19191b);
`;
